<template>
  <div class="flex flex-col">
    <div class="w-full px-2 mb-6 -mx-2 form-group">
      <select-validated
        v-model="document.type"
        :options="pricelists"
        :label="$t('modals.document.type')"
        rules="required"
        :disabled="disabled"
      />
    </div>
    <div class="w-full px-2 mb-6 -mx-2 form-group">
      <input-file-validated
        ref="document.file"
        v-model="document.file"
        :label="$t('modals.document.file')"
        accept="application/pdf"
        :disabled="disabled"
      />
    </div>
    <div class="w-full px-2 mb-6 -mx-2 form-group">
      <input-text-validated
        ref="document.comment"
        v-model="document.comment"
        input-class="w-full"
        :label="$t('modals.document.comment')"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import SelectValidated from '@/components/form/select-validated'
import InputTextValidated from '@/components/form/text-validated'
import InputFileValidated from '@/components/form/file-validated'
import { getDocumentTypes } from '@/config'

export default {
  components: {
    SelectValidated,
    InputTextValidated,
    InputFileValidated
  },
  props: {
    document: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pricelists () {
      // eslint-disable-next-line no-void
      void this.$i18n.locale
      return getDocumentTypes()
    }
  }
}
</script>
